import userAgent from '@/libs/user-agent'
import componentState from '@/mixins/component-state'
import breakpoints from '@/libs/breakpoints'
import misc from '@/mixins/misc'

export default {
  data: function () {
    return {
      openDropdown: false,
      showLoader: true
    }
  },
  mixins: [componentState, misc],
  computed: {
    isMS: function () {
      return userAgent.isIE11() || userAgent.isEdge()
    },
    isTouch: function () {
      return userAgent.isIOS() || userAgent.isAndroid()
    },
    isMobile: function () {
      return breakpoints.isMobile() || userAgent.isIpad() || userAgent.isAllMobile()
    },
    isTablet: function () {
      return breakpoints.isTablet()
    },
    isEn: function () {
      return this.$i18n.locale === 'en'
    },
    isFr: function () {
      return this.$i18n.locale === 'fr'
    },
    cssVars: function () {
      return {
        '--background': 'url(' + this.background + ')' + ' no-repeat' + ' top',
        '--color': this.color,
        '--mobileWidth': this.mobileWidth
      }
    }
  },
  mounted: function () {
    const that = this
    setTimeout(function () {
      const interval = setInterval(function () {
        if (document.readyState === 'complete') {
          clearInterval(interval)
          that.showLoader = false
        }
      }, 100)
    }, 1500)
  },
  methods: {
    go: function (route) {
      this.$router.push({ path: route, query: { r: this.refreshKey() } })
    },
    goVideo: function (url) {
      this.$store.dispatch('showVideoTourModal', { fromLandingPage: true, fromSourcePage: true, url: url })
    }
  }
}
